import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, Icon, Overlay, SelectableIcon } from '@/components';
import classnames from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import { useLocales } from '../../useLocales';
import { connectableChains, connectableWallets } from './config';
import styles from './index.module.less';
export * from './config';
export const ConnectDialog = ({ className, open, chainId, walletId, onSelect, ...rest }) => {
    const t = useLocales();
    const [currChainId, setCurrChainId] = useState(chainId);
    useEffect(() => {
        if (chainId) {
            setCurrChainId(chainId);
        }
    }, [chainId]);
    useEffect(() => {
        if (!open) {
            setCurrChainId(chainId);
        }
    }, [chainId, open]);
    const handleConnect = useCallback(({ chainId, walletId }) => {
        if (chainId && walletId && onSelect) {
            onSelect({
                chainId,
                walletId,
            });
        }
    }, []);
    if (!open)
        return null;
    return (_jsx(Overlay, { children: _jsxs(Dialog, { title: t('Connect Wallet'), open: true, className: classnames(className, styles.dialog), ...rest, children: [_jsxs("div", { className: styles.step, children: [_jsx("p", { className: styles.stepTitle, children: t('1.Choose Network') }), _jsx("div", { className: classnames(styles.stepContent, styles.list), children: connectableChains.map((c) => (_jsxs("div", { className: classnames(styles.option, {
                                    [styles.selected]: c.chainId === currChainId,
                                }), role: "button", onClick: () => setCurrChainId(c.chainId), children: [_jsx(SelectableIcon, { selected: c.chainId === currChainId, children: _jsx(Icon, { type: c.iconType, size: 48 }) }, c.name), _jsx("p", { className: styles.name, children: c.name })] }, c.name))) })] }), _jsxs("div", { className: styles.step, children: [_jsx("p", { className: styles.stepTitle, children: t('2.Choose Wallet') }), _jsx("div", { className: classnames(styles.stepContent, styles.list), children: _jsx("div", { className: classnames(styles.stepContent, styles.list), children: connectableWallets.map((w) => (_jsx("div", { className: styles.option, role: "button", onClick: () => {
                                        if (w.installed) {
                                            handleConnect({
                                                chainId: currChainId,
                                                walletId: w.id,
                                            });
                                        }
                                        else if (w.installUrl) {
                                            window.open(w.installUrl, '_blank noopener noreferrer');
                                        }
                                    }, children: _jsx(SelectableIcon, { selected: w.id === walletId, children: _jsx(Icon, { type: w.iconType, size: 48 }) }) }, w.id))) }) })] })] }) }));
};
